import { useState } from 'react';

const AutocompleteItem = (props) => {

  const {
    each,
    search
  } = props;
  const [hover, setHover] = useState(false);

  return (
    <li
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      class={"ss-list-option ng-scope" + (hover ? ' search-facet-active': '')}>
      <a href={"/products?search_query=" + each.name} class="ss-list-link ng-binding"
        dangerouslySetInnerHTML={{
          __html: each.name.replace(search, `<strong>${search}</strong>`)
        }}
      ></a>
    </li>
  )

}
export default AutocompleteItem